/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {service as OrganizationService} from "../../../Services/OrganizationService";
import autobind from "autobind-decorator";
import React from "react";
import {BaseFieldEditor} from "./BaseFieldEditor";
import Autocomplete from 'react-autocomplete';
import {StreamBankAutoCompleteItem} from "../../../Components/Common/StreamBankAutoCompleteItem";

export class OrganizationFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			orgs: [],
			value: "",
			values: []
		});
	}

	componentDidMount() {
		const {Value} = this.props;
		const {value, orgs} = this.state || {};

		OrganizationService.GetOrganizations()
			.then(x => {
				let value = "";

				if (Value) {
					const org = x.result.find(y => Number(y.organizationId) === Number(Value));

					if (org) {
						value = org.name;
					}
				}

				this.setState({
					orgs: x.result,
					value: value
				}, _ => {
					const lowercaseValue = value?.toLowerCase?.();
					const values = orgs?.filter?.(y => lowercaseValue === null || y?.name?.toLowerCase?.()?.includes?.(lowercaseValue))
						?.slice?.(0, 20);

					this.setState({values: values});
				});
			});
	}

	@autobind
	_render() {
		return <div className="autocomplete-column">
			<Autocomplete
				value={this.state.value}
				inputProps={{
					className: 'autocomplete-input',
					placeholder: "Organization",
					type: "search",
					autoComplete: "off",
				}}
				wrapperStyle={{position: 'relative', display: 'inline-block'}}
				items={this.state.values}
				getItemValue={item => item?.name}
				onChange={(event, value) => {
					this.setState({value: value}, _ => {
						if (value == '') {
							this.setState({values: []}, _ => {
								const {OnUpdate} = this.props;

								OnUpdate?.(null);
							});
						} else {
							const {orgs} = this.state || {};

							const lowercaseValue = value.toLowerCase();
							const values = orgs?.filter?.(x =>
								lowercaseValue === null || x?.name?.toLowerCase?.()?.includes?.(lowercaseValue)
							)
								?.slice(0, 20);

							this.setState({values: values});
						}
					});
				}}
				onSelect={(value, item) => {
					this.setState({value: item.name}, _ => {
						const {OnUpdate} = this.props;

						OnUpdate?.(item?.organizationId);
					});
				}}
				renderMenu={children => (
					<div className="sb-autocomplete-menu sb-autocomplete-menu-org">
						{children}
					</div>
				)}
				renderItem={(item, isHighlighted) => (
					<StreamBankAutoCompleteItem key={item.organizationId} isHighlighted={isHighlighted} item={item}/>
				)}
			/>
		</div>;
	}
}